import React from 'react';
import { navigateAction } from 'fluxible-router';
import Store from '../../../models/Store';
import shallowCompare from '../../../lib/shallowCompare';
import styles from './index.sass';
import chevronPng from '../../images/chevron_white.png';
import chevronSvg from '../../images/chevron_white.svg';

class SecondaryNavbar extends React.Component {
  static propTypes = {
    store: React.PropTypes.instanceOf(Store)
  };

  static contextTypes = {
    executeAction: React.PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      topLevelLinkSelected: null,
      overlayOpenedByHover: false,
      overlayOpenedByClick: false
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  handleOnMouseOverTopLevelLink(link) {
    this.setState({
      topLevelLinkSelected: link,
      overlayOpenedByHover: true
    });
  }

  handleOnMouseLeaveTopLevelLink(link, e) {
    if(this.state.overlayOpenedByClick || !this.state.overlayOpenedByHover || this.state.topLevelLinkSelected !== link || e.relatedTarget === this.refs.overlay) {return;}
    this.setState({
      topLevelLinkSelected: null,
      overlayOpenedByHover: false
    });
  }

  handleOnMouseLeaveOverlay(e) {
    if(this.state.overlayOpenedByClick || -1 !== _.indexOf(this.refs.topCategoryLinks.children, (c) => {return c === e.relatedTarget;})) {return;}
    this.setState({
      topLevelLinkSelected: null,
      overlayOpenedByHover: false
    });
  }

  handleOnClickTopLevelLink(link, e) {
    e.stopPropagation();
    e.preventDefault();

    if(!link.children || !link.children.length) {
      return this.context.executeAction(navigateAction, {url: e.target.pathname});
    }

    let overlayOpenedByClick = this.state.topLevelLinkSelected === link ? !this.state.overlayOpenedByClick : true;

    this.setState({
      topLevelLinkSelected: overlayOpenedByClick ? link : null,
      overlayOpenedByHover: false,
      overlayOpenedByClick
    });
  }

  handleOnClickOverlayLink(e) {
    e.stopPropagation();
    e.preventDefault();

    this.setState({
      topLevelLinkSelected: null,
      overlayOpenedByHover: false,
      overlayOpenedByClick: false
    });

    this.context.executeAction(navigateAction, {url: e.target.pathname || e.target.parentElement.pathname});

    return;
  }

  renderOverlay() {
    let { topLevelLinkSelected } = this.state;
    if(!topLevelLinkSelected || !topLevelLinkSelected.children || !topLevelLinkSelected.children.length) {return null;}

    let { children } = topLevelLinkSelected;
    let parentLinkProps = {
      className: styles.parent,
      onClick: this.handleOnClickOverlayLink.bind(this)
    };
    let childLinkProps = {
      className: styles.child,
      onClick: this.handleOnClickOverlayLink.bind(this)
    };
    let subCategories = children.map((link) => {
      let parentLink;
      if(link.text) {
        parentLink = (
          <li key="parentLink">
            <a href={link.url} {...parentLinkProps}>{link.text} <img src={chevronPng} srcSet={chevronSvg} /></a>
          </li>
        );
      }
      let childLinks = [];
      if(link.children) {
        // If single child, show all, else show first 8
        childLinks = (children.length > 1 ? link.children.slice(0, 8) : link.children).map((childLink) => {
          return (
            <li key={childLink.url}>
              <a href={childLink.url} {...childLinkProps}>{childLink.text}</a>
            </li>
          );
        });
      }
      return (
        <ul key={link.url} className={styles.subCategoryLinks}>
          {parentLink}
          {childLinks}
        </ul>
      );
    });

    return (
      <div ref="overlay" className={styles.overlay} onMouseLeave={this.handleOnMouseLeaveOverlay.bind(this)}>
        <div className={`${styles.innerContainer} ${children.length === 1 ? styles.maxHeight : ''}`}>
          {subCategories}
        </div>
      </div>
    );
  }

  render() {
    let { store } = this.props;
    let { topLevelLinkSelected } = this.state;

    let topLevelLinks = store.navigation.map((link) => {
      let liProps = {
        key: link.url,
        onMouseOver: this.handleOnMouseOverTopLevelLink.bind(this, link),
        onMouseLeave: this.handleOnMouseLeaveTopLevelLink.bind(this, link)
      };
      let aProps = {
        className: topLevelLinkSelected === link ? styles.active : '',
        href: link.url,
        onClick: this.handleOnClickTopLevelLink.bind(this, link)
      };
      return (
        <li {...liProps}>
          {aProps.href ? <a {...aProps}>{link.text}</a> : <p {...aProps}>{link.text}</p> }
        </li>
      );
    });

    return (
      <nav className={styles.secondaryNavbar}>
        <ul ref="topCategoryLinks" className={styles.topCategoryLinks}>
          {topLevelLinks}
          {store.phone_pretty ? <li className={styles.phone}><a href={`tel:${store.phone_href_format}`}>Call us {store.phone_pretty}</a></li> : null}
        </ul>
        {this.renderOverlay()}
      </nav>
    );
  }
}

export default SecondaryNavbar;



// WEBPACK FOOTER //
// banquet/components/Navbar/SecondaryNavbar/index.js